import { Component } from '@angular/core';
import { AuthUser } from '../../models/auth-user.model';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html'
})
export class UserPanelComponent {
  currentUser: AuthUser;

  constructor(private userService: UserService) {
    this.currentUser = this.userService.currentUserValue;
    this.userService.currentUser.subscribe(res => {
      this.currentUser = res;
    });
  }
}
